export const SCREEN_ROUTER = {
    LOGIN_TOKEN: '/',
    LOGIN_METHOD: '/loginMethod',
    LOGIN_COOKIE: '/loginCookie',
    LOGIN_ACCOUNT: '/loginAccount',
    DASH_BOARD: '/dashboard'
}

export const SCREEN_SETTING = {
    NO_OPEN: 0,
    SETTING_SEAFOOD: 1,
    SETTING_QUAN_DOAN: 2
}